import type { RefObject } from 'react'
import { useLayoutEffect } from 'react'
import { sigAnimate, signatureMoves } from '../../lib/signature/motion'

export function useSkeletonReveal<T extends HTMLElement>(ref: RefObject<T | null>) {
  useLayoutEffect(() => {
    const element = ref.current
    if (!element || !signatureMoves()) return

    const animation = sigAnimate(element, [{ opacity: 0 }, { opacity: 1 }], {
      duration: 120,
      delay: 150,
      fill: 'both',
    })
    return () => animation.cancel()
  }, [ref])
}
